import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Vue } from 'vue-property-decorator';
import { env } from './env';
import { analytics } from './analytics';
import { isWeChatMiniAppSync, isPeiSongApp, isWMBApp, getRouterQuery } from './util';
import { title as titleService } from '../services';
import { appEnv } from "./http";
import { BIZTYPE } from '../invoice/components/constant';

var Bridge =
/** @class */
function () {
  function Bridge() {}

  Bridge.prototype.callJSBridge = function (callback) {
    if (window['WebViewJavascriptBridge']) {
      callback(window['WebViewJavascriptBridge']);
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        window['WebViewJavascriptBridge'].init();
        callback(window['WebViewJavascriptBridge']);
      }, false);
    }
  }; // 设置标题


  Bridge.prototype.setTitle = function (title) {
    document.title = title;
  }; // 关闭 WebView


  Bridge.prototype.closeWebView = function () {
    // 通过 knb 关闭 webview
    KNB.ready(function () {
      KNB.closeWebview({});
    }); // 调用钱包 JSBridge

    bridge.callJSBridge(function (bridge) {
      bridge.callHandler('closeWebViewHandler');
    }); // 降级方案，返回上级页面

    setTimeout(function () {
      history.back();
    }, 0);
  }; // 发票列表，不使用发票（外卖使用）


  Bridge.prototype.noUseInvoice = function (msgObj) {
    var _this = this;

    if (env.appChannel === 'waimai') {
      KNB.setStorage({
        key: 'invoice-request-done',
        value: JSON.stringify(msgObj),
        success: function success() {
          KNB.setResult({
            resultCode: KNB.setResult.RESULT_OK,
            resultData: JSON.stringify(msgObj),
            success: function success() {
              _this.closeWebView();
            },
            fail: function fail() {
              _this.closeWebView();
            }
          });
        },
        fail: function fail() {
          _this.closeWebView();
        }
      });
    }
  }; // 发票列表页面：使用该发票


  Bridge.prototype.useInvoice = function (invoice) {
    return __awaiter(this, void 0, void 0, function () {
      var id, originInvoiceInfo, backInfo, isWxMiniApp, callbackurl, i, invoiceInfo;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            invoice.specialInvoice = env.specialInvoice;
            invoice.useableType = 1;
            id = invoice.id;
            originInvoiceInfo = invoice;
            backInfo = invoice;
            return [4
            /*yield*/
            , isWeChatMiniAppSync()];

          case 1:
            isWxMiniApp = _a.sent();
            callbackurl = decodeURIComponent(env.getUrlParams('backurl'));

            for (i in backInfo) {
              if (!backInfo[i]) {
                backInfo[i] = '';
              }
            } // let infoItem = env.infoItem || [];
            // infoItem.forEach(item => {
            //     backInfo[item] = invoice[item];
            // });


            if (callbackurl) {
              invoiceInfo = JSON.stringify(backInfo); // knb 参数需要encode

              if (env.callBackType === 'knbReplace' || env.callBackType === 'encodeReplace') {
                invoiceInfo = encodeURIComponent(JSON.stringify(backInfo));
              }

              if (callbackurl.indexOf('?') === callbackurl.length - 1) {
                callbackurl += "invoiceInfo=" + invoiceInfo;
              } else if (callbackurl.indexOf('?') === -1) {
                callbackurl += "?invoiceInfo=" + invoiceInfo;
              } else {
                callbackurl += "&invoiceInfo=" + invoiceInfo;
              }

              this.updateUseRecord(invoice).then(function (data) {
                console.log(data);

                if (env.callBackType === 'replace') {
                  // android webview适配
                  window.location.replace(callbackurl);
                } else if (env.callBackType === 'knbReplace') {
                  KNB.jumpWebview({
                    url: callbackurl
                  });
                } else {
                  location.href = callbackurl;
                }
              }).catch(function (e) {
                _this.closeWebView();
              });
            } else if (isWxMiniApp) {
              wx.miniProgram.postMessage({
                data: {
                  msgId: 'invoice-data',
                  invoice: invoice
                }
              });
              wx.miniProgram.navigateBack();
            } else {
              KNB.setStorage({
                key: 'invoice-request-done',
                value: JSON.stringify(invoice),
                success: function success() {
                  KNB.setResult({
                    resultCode: KNB.setResult.RESULT_OK,
                    resultData: JSON.stringify(invoice),
                    success: function success() {
                      _this.updateUseRecord(invoice).then(function (data) {
                        _this.closeWebView();
                      }).catch(function (e) {
                        _this.closeWebView();
                      });
                    },
                    fail: function fail() {
                      _this.updateUseRecord(invoice).then(function (data) {
                        _this.closeWebView();
                      }).catch(function (e) {
                        _this.closeWebView();
                      });
                    }
                  });
                },
                fail: function fail() {
                  KNB.setResult({
                    resultCode: KNB.setResult.RESULT_OK,
                    resultData: JSON.stringify(invoice),
                    success: function success() {
                      _this.updateUseRecord(invoice).then(function (data) {
                        _this.closeWebView();
                      }).catch(function (e) {
                        _this.closeWebView();
                      });
                    },
                    fail: function fail() {}
                  });
                }
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Bridge.prototype.deleteInvoice = function (item) {
    item.eventType = 'delete';
    KNB.setStorage({
      key: 'invoice-request-done',
      value: JSON.stringify(item),
      success: function success() {
        console.log('删除成功');
      },
      fail: function fail() {}
    });
    KNB.setResult({
      resultCode: KNB.setResult.RESULT_OK,
      resultData: JSON.stringify(item),
      success: function success() {
        console.log('删除成功');
      },
      fail: function fail() {}
    });
  };
  /**
   * 更新用户使用发票记录
   * @param item
   */


  Bridge.prototype.updateUseRecord = function (item) {
    return titleService.userOperationCallback({
      id: item.id
    });
  }; // 打开新的webview


  Bridge.prototype.openWebview = function (url) {
    KNB.ready(function () {
      KNB.openWebview({
        url: url
      });
    });
  }; // 打开新的webview


  Bridge.prototype.jumpWebview = function (url) {
    KNB.ready(function () {
      KNB.jumpWebview({
        url: url
      });
    });
  }; // 分享


  Bridge.prototype.share = function (id, titleStr, isRightBtn) {
    if (isRightBtn === void 0) {
      isRightBtn = false;
    } // 非美团点评微信app，不定制分享


    if (env.app !== 'group' && env.app !== 'dianping-nova' && env.app !== 'weixin') {
      return;
    }

    var url = env.urlPrefix + "share.html?invoiceId=" + encodeURIComponent(id) + "&appChannel=share";
    var title = "\u53D1\u7968\u62AC\u5934 - " + titleStr;
    var shareConfig = {
      sceneToken: 'pt-428d0f4cce958aff',
      title: title,
      content: title,
      desc: '美团点评·发票助手提供服务，点击查看抬头详情',
      image: 'https://img.meituan.net/pay/b462b88f8c249694e59e5b6b7d9e1a5f1341.png',
      url: url,
      handle: function handle() {
        analytics.reportMC('b_wfl0z42e');
      },
      success: function success(channel) {
        analytics.reportMC('b_3zcpvb72');
      }
    };
    console.log('shared url:', url);
    KNB.ready(function () {
      if (isRightBtn) {
        KNB.configShare(shareConfig);
      } else {
        KNB.share(shareConfig);
      }
    });
  }; // 清除右上角分享按钮


  Bridge.prototype.clearRRBtn = function () {
    if (env.app !== 'group' && env.app !== 'dianping-nova') {
      return;
    }

    KNB.ready(function () {
      KNB.setNavButtons({
        position: 'RR',
        disable: 1
      });
    });
  }; // 登录


  Bridge.prototype.login = function () {
    var _this = this;

    KNB.ready(function () {
      switch (env.app) {
        case 'group':
        case 'conch':
        case 'dianping-nova':
        case 'zhenguo':
        case 'waimai':
        case 'peisong_pt':
        case 'waimaiB':
          return _this.knbLogin();

        default:
          return _this.webLogin();
      }
    });
  };

  Bridge.prototype.webLogin = function () {
    var iloginMap = {
      prod: "https://passport.meituan.com/useraccount/ilogin?risk_partner=-1&risk_app=-1&risk_platform=3&backurl=" + encodeURIComponent(location.href),
      test: "https://passport.fe.test.sankuai.com/useraccount/ilogin?risk_partner=-1&risk_app=-1&risk_platform=3&backurl=" + encodeURIComponent(location.href),
      local: "https://passport.fe.test.sankuai.com/useraccount/ilogin?risk_partner=-1&risk_app=-1&risk_platform=3&backurl=" + encodeURIComponent(location.href)
    };
    location.href = iloginMap[appEnv];
  };

  Bridge.prototype.knbLogin = function () {
    var _this = this;

    KNB.ready(function () {
      KNB.login({
        success: function success() {
          KNB.jumpWebview({
            url: location.href
          });
        },
        fail: function fail() {
          _this.closeWebView();
        }
      });
    });
  }; // 页面跳转
  // 在 webview 环境里使用新开 webview 的方式打开新页面


  Bridge.prototype.redirect = function (url, replace) {
    var prefix = '';

    var getPrefix = function getPrefix(scheme) {
      return scheme + "://www.meituan.com/web?url=";
    };

    switch (env.app) {
      case 'group':
        prefix = getPrefix('imeituan');
        break;

      case 'conch':
        prefix = getPrefix('iconch');
        break;

      case 'waimai':
      case 'movie':
        prefix = getPrefix('meituanpayment');
        break;

      case 'dianping-nova':
        prefix = env.system === 'android' ? '' : 'dianping://web?url=';
        break;
    }

    url = prefix ? prefix + encodeURIComponent(url) : url;

    if (replace) {
      location.replace(url);
    } else {
      location.href = url;
    }
  }; // 设置 webview 背景色


  Bridge.prototype.setBackGroundColor = function (color) {
    if (env.system === 'iphone') {
      KNB.ready(function () {
        KNB.setBackgroundColor({
          color: color
        });
      });
    }
  };

  Bridge.prototype.getFingerFrint = function () {
    return KNB.getPromiseInstance().getFingerprint();
  }; // 关闭 webview


  Bridge.prototype.justCloseWebView = function () {
    KNB.closeWebview({});
  }; // 设置返回按钮


  Bridge.prototype.setLLButton = function (onClick, onSuccess, onFail) {
    KNB.ready(function () {
      KNB.setLLButton({
        icon: 'H5_Back',
        handle: function handle() {
          onClick && onClick();
        },
        success: function success() {
          onSuccess && onSuccess();
        },
        fail: function fail() {
          onFail && onFail();
        }
      });
    });
  }; // 开票申请成功


  Bridge.prototype.invoiceRequestDone = function (msgObj, closeCurrentView) {
    var app = env.app;
    var bizType = getRouterQuery('bizType');

    if (app === 'group' || app === 'dianping-nova' || app === 'waimai') {
      // TODO: 同时调用setStorage\setResult，业务方全部切到setStorage后，删除setResult。 2019.01.10
      KNB.setStorage({
        key: 'invoice-request-done',
        value: JSON.stringify(msgObj),
        success: function success() {
          KNB.setResult({
            resultCode: KNB.setResult.RESULT_OK,
            resultData: JSON.stringify(msgObj),
            success: function success() {
              if (closeCurrentView) bridge.closeWebView();
            },
            fail: function fail() {
              if (closeCurrentView) bridge.closeWebView();
            }
          });
        },
        fail: function fail() {
          KNB.setResult({
            resultCode: KNB.setResult.RESULT_OK,
            resultData: JSON.stringify(msgObj),
            success: function success() {
              if (closeCurrentView) bridge.closeWebView();
            },
            fail: function fail() {}
          });
        }
      });
    } else if (app === 'weixin') {
      if (env.appChannel === 'paotui') {
        // 通知成功并返回至原小程序
        wx.miniProgram.postMessage({
          data: msgObj
        });
        if (closeCurrentView) wx.miniProgram.navigateBack();
      } else {
        if (closeCurrentView) WeixinJSBridge.invoke('closeWindow');
      }
    } else if (Number(bizType) === BIZTYPE.PaoTuiB && (app === 'peisong_pt' || app === 'waimaiB' || isPeiSongApp || isWMBApp)) {
      KNB.setStorage({
        key: 'invoice-request-done',
        value: JSON.stringify(msgObj)
      });
    }
  };

  return Bridge;
}();

export var bridge = new Bridge();
Vue.prototype.$bridge = bridge;